"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var reactIntl=require("react-intl"),o=reactIntl.defineMessages({chooseFile:{defaultMessage:"Choose File",id:"app.chooseFile"},emptyState:{defaultMessage:"No file selected",id:"app.emptyState"}});exports.default=o;
//# sourceMappingURL=messages.js.map
